import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames'

export const IconErrorSVG = ({color, className, ...rest}) => {
    return (
        <svg {...rest} width = "25" height = "25" viewBox = "0 0 25 25" fill={color}
             className={classNames(['svg-icon svg-error', className])}>
            <path className="svg-error_a"
                  d="M14.5,2A12.5,12.5,0,1,0,27,14.5,12.5,12.5,0,0,0,14.5,2Zm0,13.75a1.254,1.254,0,0,1-1.25-1.25v-5a1.25,1.25,0,1,1,2.5,0v5A1.254,1.254,0,0,1,14.5,15.75Zm1.25,5h-2.5v-2.5h2.5Z"
                  transform="translate(-2 -2)"/>
        </svg>
    );
};


IconErrorSVG.propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

IconErrorSVG.defaultProps = {
    color: '#fff',
    className: '',
};

export default IconErrorSVG;